import { z } from "zod"

// ====== HELPERS ======
// Coerce string inputs to number and validate against a union of number literals
export const coerceToLiteralNumbers = <L extends number>(literals: readonly L[]) => {
  if (literals.length === 0) {
    throw new Error("coerceToLiteralNumbers requires at least one literal value")
  }
  let unionSchema = z.literal(literals[0]) as unknown as z.ZodType<L>
  for (let i = 1; i < literals.length; i++) {
    unionSchema = z.union([unionSchema, z.literal(literals[i])]) as z.ZodType<L>
  }
  return z.coerce.number().pipe(unionSchema)
}

// ====== UNIVERSAL VIDEO GENERATION SCHEMAS ======

// Base schema for all video generation models - minimal universal fields
export const baseVideoGenerationSchema = z.object({
  prompt: z.string().min(1),
})

// ====== UNIVERSAL IMAGE GENERATION SCHEMAS ======

// Base schema for all image generation models - minimal universal fields
export const baseImageGenerationSchema = z.object({
  prompt: z.string().min(1),
})

// ====== UNIVERSAL AUDIO GENERATION SCHEMAS ======

// Base schema for all audio generation models - minimal universal fields
export const baseAudioGenerationSchema = z.object({
  prompt: z.string().min(1),
})
